// Grouped services navigation — used by the Navbar dropdown. Groups are
// commercial buyer clusters, not marketing categories. Every entry maps
// to a Phase 3.1 canonical service URL. Two legacy services (ERP + E-commerce)
// are surfaced under "Software & Platforms" and "Product Development" so
// they remain reachable through nav.

export const SERVICES_MENU = [
  {
    heading: "AI & Automation",
    items: [
      { label: "AI Development",       path: "/services/ai-development",       tagline: "Copilots, agents, doc AI." },
      { label: "AI Agent Development", path: "/services/ai-agent-development", tagline: "Task-completing agents." },
    ],
  },
  {
    heading: "Software & Platforms",
    items: [
      { label: "Custom Software Development",  path: "/services/custom-software-development",  tagline: "Bespoke business platforms." },
      { label: "SaaS Development",             path: "/services/saas-development",             tagline: "Multi-tenant, billing-ready." },
      { label: "CRM Development",              path: "/services/crm-development",              tagline: "Custom sales & admissions CRMs." },
      { label: "Web Application Development",  path: "/services/web-application-development",  tagline: "Dashboards, portals, marketplaces." },
      { label: "Software Modernisation",       path: "/services/software-modernisation",       tagline: "Replatform legacy without a rewrite." },
      { label: "ERP Development",              path: "/services/erp-development",              tagline: "Finance / HR / operations in one place." },
    ],
  },
  {
    heading: "Product Development",
    items: [
      { label: "Mobile App Development", path: "/services/mobile-app-development", tagline: "iOS, Android & cross-platform." },
      { label: "MVP Development",        path: "/services/mvp-development",        tagline: "Napkin → paying customer in 8–12 weeks." },
      { label: "E-Commerce Development", path: "/services/ecommerce-development",  tagline: "Storefronts, headless & marketplaces." },
    ],
  },
  {
    heading: "Industry Solutions",
    items: [
      { label: "EdTech Software Development", path: "/services/edtech-development", tagline: "Admissions, LMS, campus ERPs, AI." },
    ],
  },
];
